/**
 * NOTA: file condiviso tra le varie aree (home, customer/dealer/admin area)
 */

require('./bootstrap');

$(document).ready(function () {

    $('.btn-lang').click(function () {
        let lang = $(this).data("lang");
        let currentPath= window.location.pathname + window.location.search;

        //let newPath= currentPath.replace('/'+ currentLocale +'/', '/'+ lang +'/')
        let newPath= '/'+ lang +'/' + currentPath.substr(4);

        window.location.href = newPath;
    });

    $('.btn-home').click(function () {
        let url = $(this).data("target");

        window.location.href = url;
    });
});
